import { MIN_SEARCH_LENGT, SEARCH_VALID_REGEXP, SEARCH_COORDINATES_REGEXP } from 'common/constants/search';
import {
  between,
  parseCoordinatesFromString
} from 'shared/utils';

export const isValidSearchLength = (value: string) => value.length >= MIN_SEARCH_LENGT;
export const isValidSearchCharacters = (value: string = '') => SEARCH_VALID_REGEXP.test(value);
export const isCoordinatesSearch = (value: string) => SEARCH_COORDINATES_REGEXP.test(value);
export const isValidCoordinatesSearch = (value: string) => {
  if (!isCoordinatesSearch(value)) return false;

  const [latitude, longitude] = parseCoordinatesFromString(value);

  return between(latitude, -90, 90) && between(longitude, -180, 180)
};
